import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { LogoHorizontal } from '../components/Logo';
import { TextInput } from '../components/Input';
import { PrimaryButton } from '../components/Button';
import { FormHeader } from '../components/Card';
import api, { formatApiError } from '../lib/api';

export default function ForgotPassword() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [sent, setSent] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [devToken, setDevToken] = useState(null);

    const submit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            const { data } = await api.post('/auth/forgot-password', { email: email.trim().toLowerCase() });
            setSent(true);
            if (data.dev_token) setDevToken(data.dev_token);
        } catch (err) {
            setError(formatApiError(err));
        } finally { setLoading(false); }
    };

    return (
        <div className="min-h-screen bg-surface app-shell flex flex-col py-8 px-6">
            <div className="flex justify-center mb-6"><LogoHorizontal size="lg" /></div>

            <div className="bg-white rounded-[24px] shadow-card p-6 fade-up">
                <FormHeader title="Iniciar Sesión" subtitle="Ingresa tu cuenta de correo electrónico para enviarte instrucciones de restablecimiento de contraseña." />

                {!sent ? (
                    <form onSubmit={submit} className="space-y-4">
                        <TextInput label="Correo electrónico" type="email" icon={Mail} placeholder="tu@correo.com" value={email} onChange={(e) => setEmail(e.target.value)} required testId="forgot-email-input" />
                        {error && <div className="text-red-500 text-sm font-medium" data-testid="forgot-error">{error}</div>}
                        <PrimaryButton type="submit" loading={loading} testId="forgot-submit-btn">Enviar instrucciones</PrimaryButton>
                    </form>
                ) : (
                    <div className="text-center">
                        <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <Mail className="w-9 h-9 text-emerald-500" />
                        </div>
                        <p className="text-gray-700 font-medium mb-2">¡Listo!</p>
                        <p className="text-sm text-gray-500">Si el correo existe, te enviamos instrucciones para restablecer tu contraseña.</p>
                        {devToken && (
                            <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-2xl text-xs text-yellow-800" data-testid="forgot-dev-token">
                                <div className="font-bold mb-1">Modo DEV — token de prueba:</div>
                                <button onClick={() => navigate(`/restablecer-contrasena?token=${devToken}`)} className="text-yellow-900 underline break-all">{devToken}</button>
                            </div>
                        )}
                    </div>
                )}

                <button onClick={() => navigate('/intro')} className="block mx-auto mt-6 text-gray-500 text-sm hover:text-gray-700" data-testid="forgot-back-home">
                    Volver al Inicio
                </button>
            </div>
        </div>
    );
}
